import {useEffect, useState} from 'react'
import {MultiSelect, Option} from 'react-multi-select-component'

import '../../style/multiSelectSucess.css'

import {getFranchises} from '../../pages/chooseFranchise/core/_request'
import Swal from 'sweetalert2'
interface IListSearchFranchises {
  setSelectsFranchisesSearch: (value: string) => void
  selectsFranchises: Option[]
  setSelectsFranchises: (value: Option[]) => void
  label: string
}
const ListSearchFranchises = ({
  setSelectsFranchisesSearch,
  selectsFranchises,
  setSelectsFranchises,
  label,
}: IListSearchFranchises) => {
  const initialSelectValue = [{value: '', label: ''}]
  const [franchises, setFranchises] = useState<Option[]>(initialSelectValue)

  useEffect(() => {
    async function init() {
      try {
        const data = await getFranchises()
        const formattedData = data?.map((item: any) => ({
          value: String(item.id),
          label: item.name,
        }))
        setFranchises(formattedData || [])
      } catch (error: any) {
        setFranchises([])
        await Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: error?.response?.data?.message || 'Ocorreu um erro ao carregar as unidades',
          timer: 2000,
        })
      }
    }
    init()
  }, [])

  return (
    <>
      <div className='mb-5'>
        <label className='form-label fs-6 fw-bold'>{label}</label>
        <MultiSelect
          className='form-control rmscStyle'
          data-kt-user-table-filter='unidades'
          options={franchises}
          value={selectsFranchises}
          onChange={(option) => {
            const valores = option.map((item) => item.value)
            setSelectsFranchisesSearch(valores)
            setSelectsFranchises(option)
          }}
          labelledBy={''}
          overrideStrings={{
            selectSomeItems: 'Selecione a(as) unidades',
            search: 'Procurar',
            selectAll: 'Selecionar todas',
            allItemsAreSelected: 'Todas unidades selecionadas',
          }}
        />
      </div>
    </>
  )
}

export {ListSearchFranchises}
